<mat-grid-list [cols]="1">
  <huge-row>
    @for (alert of data; track alert; let i = $index) {
    <mat-col size-xs="12" size-md="4">
      <div class="wrapper ion-margin">
        <div class="main-content">
          <h1 class="alert-title">{{ alert.AlertTypeName }}</h1>
          <form [formGroup]="emailFormGroup">
            <mat-form-field class="full-width">
              <mat-label class="input-label">Send to:</mat-label>
              <input matInput name="receiverEmail" formControlName="{{ alert.EmailFormControl }}" (keyup.enter)="addSetting(alert, false)" />
            </mat-form-field>
            @if ( (isLoaded && emailFormGroup.get(alert.EmailFormControl).errors) || emailFormGroup.get(alert.EmailFormControl).hasError('required') ) {
            <div class="validation-error-message"> Enter a valid email </div>
            }
          </form>
          <div class="email-chip-section">
            <div class="email-chip-content">
              @for (email of alert.RecipientEmails; track email; let i = $index) {
              <div class="email-chip">
                <p class="email">
                  {{ email }}
                </p>
                @if (!disabled) {
                <mat-icon class="remove-icon" (click)="removeRecipient(alert, i)">
                  <img src="assets/icon/close-outline.svg" />
                </mat-icon>
                }
              </div>
              }
            </div>
            @if (!disabled) {
            <mat-icon size="medium" class="add-icon" (click)="addSetting(alert, false)">add_circle_outline</mat-icon>
            }
          </div>
        </div>
        @if (alert.TypeID == 4) {
					<form [formGroup]="usagePerDeviceCapForm">
						<!-- <huge-row> -->
							<mat-form-field style="width: 80%;">
								<mat-label>Usage cap per device(MB):</mat-label>
								<input matInput
									type="number"
									formControlName="cap"
									(keyup.enter)="addSetting(alert, false)"
                />
							</mat-form-field>
              @if (usagePerDeviceCapForm.get('cap').value != originalCapValue) {
                <button mat-mini-fab (click)="resetCapValue()"><mat-icon>close</mat-icon></button>
                <button mat-mini-fab (click)="addSetting(alert,false)"><mat-icon>checkmark</mat-icon></button>
              }
						<!-- </huge-row> -->
            @if (isLoaded && usagePerDeviceCapForm.get('cap').errors) {
              <div
                class="validation-error-message">
                Enter a valid amount
              </div>
            }
						<div class="row">
							<div [class.active]="alert.ToggleFormControl.value == false">Fixed</div>
							<label class="switch">
								<input
								type="checkbox"
								[checked]="isMonthlyCappedControl"
								[formControl]="isMonthlyCappedControl"
								(change)="addSetting(alert, false)"
								/>
								<span class="slider round"></span>
							</label>
							<div>Monthly</div>
						</div>
					</form>
        }
        <div class="footer">
          @if (alert.TypeID != 4) {
            <p>Receive notifications</p>
          } @else {
            <p>Enable capping</p>
          }
          <label class="switch">
            <form [formGroup]="notificationsToggleFormGroup">
              <input type="checkbox" [formControlName]="alert.ToggleFormControl" (change)="addSetting(alert, false)" />
              <span class="slider round"></span>
            </form>
          </label>
        </div>
      </div>
    </mat-col>
    }
  </huge-row>
</mat-grid-list>
